var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLake4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1209_34)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1209_34)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.0001,
    cy: 15.0001,
    rx: 13.9583,
    ry: 13.9583,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.3723 6.90961C9.3445 7.99295 7.42783 10.0207 6.53895 13.0485C5.73339 15.8818 6.65006 19.3818 8.81672 21.5485C12.2056 24.9096 17.9278 24.9096 21.3167 21.5485C23.8445 18.9929 24.5945 14.8541 23.0945 11.6596C21.1778 7.60406 16.4001 5.46517 12.3723 6.90961ZM18.4556 7.74295C20.0945 8.46517 21.9001 10.2707 22.6501 11.9374C23.4834 13.7152 23.4834 16.8818 22.6501 18.6596C21.9001 20.3263 20.0945 22.1318 18.4278 22.8818C16.6501 23.7152 13.4834 23.7152 11.7056 22.8818C8.12228 21.2429 6.0945 17.1596 7.01117 13.3818C8.20561 8.38183 13.7334 5.65961 18.4556 7.74295Z",
    fill: "#87CEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7057 9.79841C11.0668 10.9095 9.98351 12.7429 9.34462 13.8817C8.67795 15.0206 8.17795 16.0206 8.26128 16.0762C8.51128 16.3262 8.95573 15.7706 9.95573 13.9651C11.2335 11.6595 11.0946 11.8262 11.5946 12.2429C11.928 12.5206 12.0946 12.5206 12.4557 12.2151C12.8168 11.9373 13.0113 11.9373 13.4557 12.2151C13.8724 12.4651 14.0946 12.4651 14.4002 12.2151C14.8724 11.8262 14.7335 11.6595 16.1502 14.104C16.7891 15.2151 17.4557 16.1317 17.5946 16.1317C17.7613 16.1317 17.8446 16.0484 17.7891 15.9095C17.4557 15.1595 13.2891 8.04841 13.0946 7.9373C12.9835 7.85396 12.3446 8.6873 11.7057 9.79841ZM13.8168 10.104C14.2057 10.7706 14.5113 11.3817 14.5113 11.4651C14.5113 11.5484 13.8168 11.604 12.9835 11.604C12.1502 11.604 11.4557 11.5484 11.4557 11.4929C11.4557 11.2984 12.8724 8.90952 13.0113 8.90952C13.0668 8.90952 13.428 9.46507 13.8168 10.104Z",
    fill: "#87CEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6778 8.13176C15.4834 8.3262 15.3445 8.79842 15.3445 9.18731C15.3445 10.6595 16.9278 11.104 17.7334 9.88176C18.15 9.24287 18.15 9.13176 17.7334 8.49287C17.2334 7.74287 16.2334 7.5762 15.6778 8.13176ZM17.2334 9.02065C17.3723 9.68731 16.9556 10.0762 16.3723 9.85398C15.9 9.68731 15.7334 8.88176 16.0945 8.52065C16.4278 8.18731 17.15 8.49287 17.2334 9.02065Z",
    fill: "#87CEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7056 11.7708C16.9556 13.0763 16.8723 13.3541 17.2334 13.3541C17.3723 13.3541 17.7056 12.9374 17.9834 12.4097C18.289 11.8819 18.5945 11.493 18.7056 11.5763C18.8167 11.6319 19.4279 12.6319 20.0667 13.7708C21.1501 15.7152 21.6223 16.3263 21.8723 16.0763C22.039 15.9097 18.9279 10.5763 18.6501 10.5763C18.539 10.5763 18.0945 11.1319 17.7056 11.7708Z",
    fill: "#87CEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.70569 16.993C7.42792 17.4375 8.90014 20.1875 9.84458 20.993C10.9835 21.9653 11.2057 21.6319 10.1501 20.493C9.09458 19.3541 8.40014 18.3264 8.40014 17.8819C8.40014 17.6041 9.84458 17.5208 15.0668 17.5208C20.2612 17.5208 21.7335 17.6041 21.7335 17.8819C21.7335 18.5208 20.3446 20.2986 19.2057 21.1319C17.2057 22.5764 15.1779 22.7708 12.0946 21.8264C11.7057 21.6875 11.4557 21.743 11.4557 21.9375C11.4557 22.1041 12.1779 22.4375 13.039 22.6875C15.6224 23.4375 18.0668 22.8541 20.289 20.993C21.2335 20.1875 22.7057 17.4375 22.4279 16.993C22.1779 16.5764 7.95569 16.5764 7.70569 16.993Z",
    fill: "#87CEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.37222 18.3542C9.59444 18.7153 11.65 18.7153 11.8722 18.3542C11.9833 18.1875 11.5111 18.0764 10.6222 18.0764C9.73333 18.0764 9.26111 18.1875 9.37222 18.3542Z",
    fill: "#87CEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7055 18.3542C12.9278 18.7153 20.5389 18.7153 20.7611 18.3542C20.8722 18.1875 19.4555 18.0764 16.7333 18.0764C14.0111 18.0764 12.5944 18.1875 12.7055 18.3542Z",
    fill: "#87CEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0667 19.4651C10.0667 19.6318 11.4 19.7429 13.5389 19.7429C15.6778 19.7429 17.0111 19.6318 17.0111 19.4651C17.0111 19.2985 15.6778 19.1874 13.5389 19.1874C11.4 19.1874 10.0667 19.2985 10.0667 19.4651Z",
    fill: "#87CEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9556 20.5763C13.9556 20.9374 18.5945 20.9374 18.8167 20.5763C18.9278 20.4097 18.0667 20.2986 16.4833 20.2986C14.9833 20.2986 13.9556 20.4097 13.9556 20.5763Z",
    fill: "#87CEFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1209_34",
    x: -0.958252,
    y: -0.958252,
    width: 31.9167,
    height: 31.9167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1209_34"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1209_34",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1209_34"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30.2083,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLake4);
export default __webpack_public_path__ + "static/media/lake-_4_.96b952c4f457b795d2e75cdcd989b12e.svg";
export { ForwardRef as ReactComponent };